module.exports = __webpack_public_path__ + "static/media/Smart.f6e0b3c9.png";